/* eslint-disable react/require-default-props */
import { Box, Button, Divider } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import SelectTemplate from '@src/components/Template/SelectTemplate';
import Typography from '@src/components/UI/Typography';
import { fetchWhatsAppTemplatesByContactId } from '@src/reducers/whatsAppTemplates';
import {
  selectDefaultWhatsAppTemplateByContactId,
  selectWhatsAppTemplates,
} from '@src/selectors/whatsAppTemplates';
import { TemplatedMsgWrapper } from '@src/types';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

const OutgoingCallTemplateForm: React.FC<{
  onSubmit: (template?: TemplatedMsgWrapper) => void;
  disabled?: boolean;
}> = ({ onSubmit, disabled = false }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { contactTemplates } = useSelector(selectWhatsAppTemplates);
  const defaultTemplate = useSelector(selectDefaultWhatsAppTemplateByContactId);

  const emptyTemplates = contactTemplates.length === 0;

  const [selectedTemplate, setSelectedTemplate] =
    useState<TemplatedMsgWrapper>();
  const [isShowTemplates, setIsShowTemplates] = useState(false);

  const onChangeTemplate = (templateId: number) => {
    const newSelectedTemplate = contactTemplates.find(
      ({ templatedMsg }) => templatedMsg.id === templateId
    );

    if (newSelectedTemplate) setSelectedTemplate(newSelectedTemplate);
    setIsShowTemplates(false);
  };

  const onToggleShowTemplates = () => {
    setIsShowTemplates(prev => !prev);
  };

  useEffect(() => {
    setSelectedTemplate(defaultTemplate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTemplate]);

  useEffect(() => {
    dispatch(
      fetchWhatsAppTemplatesByContactId({ showCallPermissionOnly: true })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={8}
        style={{ background: 'inherit' }}
      >
        <Typography fontWeight="semibold" variant="body-m">
          {formatMessage({
            id: 'CallPermission.Template.SendTemplate.TitleLbl',
          })}
        </Typography>
        {!emptyTemplates && (
          <Typography variant="body-s">
            {formatMessage({
              id: 'CallPermission.Template.SendTemplate.ContentLbl',
            })}
          </Typography>
        )}

        <Box maxHeight={400} maxWidth={450} overflow="auto" mt={2}>
          {selectedTemplate && (
            <SelectTemplate
              onSelectedTemplate={onChangeTemplate}
              selectedTemplate={selectedTemplate!}
              templatedMsgs={contactTemplates}
              showTemplates={isShowTemplates}
              onShowTemplates={onToggleShowTemplates}
              allowClass={false}
            />
          )}
          {emptyTemplates && (
            <Box mb={1}>
              <Alert severity="info">
                {formatMessage({ id: 'TemplatedMsg.templateNoAvailable' })}
              </Alert>
            </Box>
          )}
        </Box>

        {!emptyTemplates && (
          <Box my={2}>
            <Divider />
          </Box>
        )}

        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={() => onSubmit(selectedTemplate)}
          disabled={disabled || emptyTemplates}
        >
          {formatMessage({ id: 'CallPermission.Template.SendTemplate.BtnLbl' })}
        </Button>
      </Box>
    </>
  );
};

export default OutgoingCallTemplateForm;
